<template>
  <FormModal
    :visible="showModalCreate > 0"
    title="Termos de uso"
    :hide-footer="true"
    width="600px"
    @update:visible="closeModal"
  >
    <template #header>
      <div class="flex items-center gap-3">
        <svg class="w-10 h-10 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        <h2 class="text-xl font-semibold text-gray-900 dark:text-gray-100">Termos de uso</h2>
      </div>
    </template>

    <template #default>
      <div class="space-y-4">
        <!-- Conteúdo dos termos -->
        <div 
          class="border border-gray-200 dark:border-slate-700 rounded-lg p-4 bg-gray-50 dark:bg-slate-800 max-h-80 overflow-y-auto"
          v-html="conteudoTermos"
        >
        </div>

        <!-- Mensagem de erro -->
        <div v-if="erroConfirmar" class="flex items-center gap-2 p-3 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
          <svg class="w-5 h-5 text-red-600 dark:text-red-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span class="text-sm text-red-800 dark:text-red-200">Necessário aceitar os termos para confirmar adesão ao produto</span>
        </div>

        <!-- Checkbox de aceite -->
        <label class="flex items-start gap-3 cursor-pointer group">
          <input
            type="checkbox"
            v-model="aceitoTermos"
            :disabled="bloquearAceite"
            class="mt-0.5 w-4 h-4 text-primary bg-gray-100 border-gray-300 rounded focus:ring-primary dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
          />
          <span class="text-sm text-gray-700 dark:text-gray-300 group-hover:text-gray-900 dark:group-hover:text-gray-100 transition-colors"
            :class="{ 'opacity-50': bloquearAceite }">
            Li e aceito os termos de uso.
          </span>
        </label>

        <!-- Botões de ação -->
        <div class="flex gap-3 pt-2">
          <button
            v-if="!bloquearAceite"
            @click="confirmar"
            class="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors"
          >
            Confirmar
          </button>
          <button
            @click="closeModal"
            class="flex-1 px-4 py-2.5 text-sm font-medium text-gray-700 dark:text-white bg-white dark:bg-slate-700 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-600 transition-colors"
          >
            {{ bloquearAceite ? 'Fechar' : 'Voltar' }}
          </button>
        </div>
      </div>
    </template>
  </FormModal>
</template>

<script>
import { mapGetters } from "vuex";
import api from '@/api/axios';
import FormModal from '@/components/FormModal.vue';

export default {
    components: {
        FormModal,
    },
    computed: {
        ...mapGetters({
            showModalCreate: "GET_MODAL_TERMOS_PRODUTOS",
            bloquearAceite: 'GET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE',
            listaProdutos: 'GET_LISTA_PRODUTOS',
            user: 'auth/user',
        }),
    },
    data() {
        return { 
            nomeEmpresa: '',
            conteudoTermos: '',
            aceitoTermos: false,
            erroConfirmar: false,
        }
    },
    mounted(){
        this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
    },
    watch: {
        showModalCreate(){
            if(this.showModalCreate > 0){
                this.conteudoTermos = this.listaProdutos?.filter(produto => produto.ProdutoId == this.showModalCreate)[0].TermoAdesao;
            }else{
                this.conteudoTermos = '';
                this.aceitoTermos = false;
                this.erroConfirmar = false;
            }
        }
    },
    methods: {
        closeModal() {
            this.$store.commit("SET_MODAL_TERMOS_PRODUTOS", 0);
            this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE", false);
            this.aceitoTermos = false;
            this.erroConfirmar = false;
        },

        async confirmar(){
            if(!this.aceitoTermos){
                this.erroConfirmar = true;
            }else{

                try {
                     

                    var obj = { ProdutoId: this.showModalCreate, Aceite: true, DataAceite: new Date() };

                    const retorno = await api.post('/cliente/produtos', obj);
                    if (retorno.status === 200 && this.nomeEmpresa != 'ACTUAL') {
                            this.$alert({
                                icon: 'success',
                                title: 'Produto incluído',
                                text: 'Produto adicionado com sucesso',
                            }).then((result) => {
                                if (result.value) {
                                    this.$store.commit("SET_MODAL_TERMOS_PRODUTOS", 0);
                                    this.$store.dispatch('FETCH_CONSULTA_LISTA_PRODUTOS');
                                    this.$store.dispatch('FETCH_CONSULTA_LISTA_PRODUTOS_CLIENTE');
                                }
                            });
                    }else if(retorno.status === 200 && this.nomeEmpresa == 'ACTUAL'){
                            this.$alert({
                                icon: 'success',
                                title: 'Produto incluído',
                                text: 'Produto assinado com sucesso',
                            }).then((result) => {
                                if (result.value) {
                                    this.$store.commit("SET_MODAL_TERMOS_PRODUTOS", 0);
                                    this.$store.dispatch('FETCH_CONSULTA_LISTA_PRODUTOS');
                                    this.$store.dispatch('FETCH_CONSULTA_LISTA_PRODUTOS_CLIENTE');
                                }
                            });
                    }
                } catch (error) {
                    console.error('Erro na API:', error);
                    this.$alert({
                        icon: 'error',
                        title: 'Oops...',
                        text: `Falha ao adicionar produto ao cliente: ${error.response?.data?.data[0] || error.message}`,
                    });


            }
        }
        }
    },
};
</script>

<style scoped>
/* Estilos customizados para o conteúdo HTML dos termos */
:deep(.border) {
  font-size: 0.875rem;
  line-height: 1.5;
}

/* Cores gerenciadas pelas classes Tailwind text-gray-700 dark:text-gray-300 */
</style>
